import { useSelector } from "react-redux";
import { useMemo } from "react";
import { RootState } from "../../../../state/store";
import { getEnvValueFor } from "../../../../helpers/utils";

const WidgetMarketingOverlay = ({
  children,
  height,
  width,
  marketingHtmlUrl = "",
}: {
  children: React.ReactNode;
  height: number;
  width: number;
  marketingHtmlUrl?: string;
}) => {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const iframeSrc = useMemo(() => {
    const version = getEnvValueFor("RELEASE_VERSION");
    if (marketingHtmlUrl) {
      return `${marketingHtmlUrl}&theme=${theme}&version=${version}`;
    }
    return null;
  }, [marketingHtmlUrl, theme]);

  return (
    <>
      <div
        className="iframe-overlay"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          height: "270px",
          width: `85%`,
          zIndex: 1000,
          borderRadius: "30px",
          backgroundColor: "transparent",
        }}>
        <iframe
          key={iframeSrc}
          title="widget locked"
          src={iframeSrc}
          height={"100%"}
          width={"100%"}
          style={{
            borderRadius: "30px",
            backgroundColor: "transparent",
            boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
          }}
          allowTransparency
          frameBorder="0"
          scrolling="no"
          allow="allow-modal allow-popups allow-same-origin allow-top-navigation"></iframe>
      </div>
      {children}
    </>
  );
};

export default WidgetMarketingOverlay;
